import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./accordion";
import { Alert, AlertDescription, AlertTitle } from "./alert";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "./alert-dialog";
import { Badge } from "./badge";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "./breadcrumb";
import { Button, ButtonLabel } from "./button";
import { ButtonGroup, ButtonGroupSeparator, ButtonGroupText } from "./button-group";
import { Calendar } from "./calendar";
import { Call, CallDescription, CallTitle } from "./call";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./card";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselNextButton,
    CarouselPrevious,
    CarouselPreviousButton,
} from "./carousel";
import { Checkbox } from "./checkbox";
import { Checkbox as CheckboxSlate } from "./checkbox-slate";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./collapsible";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from "./command";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "./dialog";
import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
} from "./drawer";
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "./dropdown-menu";
import { FieldIconButton } from "./field-icon-button";
import { FlowProgress } from "./flow-progress";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "./form";
import { Input } from "./input";
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from "./input-otp";
import { Label } from "./label";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { RadioGroup, RadioGroupItem } from "./radio-group";
import { RadioCardGroup, RadioCardItem } from "./radio-card-group";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "./resizable";
import { ScrollArea, ScrollBar } from "./scroll-area";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "./select";
import { NativeSelect, NativeSelectOption, NativeSelectOptGroup } from "./native-select";
import { Separator } from "./separator";
import {
    Sheet,
    SheetClose,
    SheetContent,
    SheetDescription,
    SheetFooter,
    SheetHeader,
    SheetOverlay,
    SheetPortal,
    SheetTitle,
    SheetTrigger,
} from "./sheet";
import Section from "./section";
import SectionTitle from "./section-title";
import { Skeleton } from "./skeleton";
import { Switch } from "./switch";
import { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow } from "./table";
import { Tabs, TabsContent, TabsList, TabsTrigger, NavTabs, NavTabsList, NavTabsLink } from "./tabs";
import { Textarea } from "./textarea";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";
import { Title } from "./title";
import { Subtitle } from "./subtitle";
import { Toast, ToastAction, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "./toast";
import { useToast, toast } from "./use-toast";
import { MultiSelect } from "./multi-select";
import { FormBadge } from "./form-badge";
import { FormBadgeGroup } from "./form-badge-group";
import { FormInfoRow } from "./form-info-row";
import { FormSectionCard } from "./form-section-card";
import { FormPrevalenceBadge } from "./form-prevalence-badge";
import { FormStatusBadge } from "./form-status-badge";
import { FormImportanceBadge } from "./form-importance-badge";
import { FormScoringBadge } from "./form-scoring-badge";
import { SubscriptionPlanBadge } from "./subscription-plan-badge";
import { cn } from "./utils";

export const ui: Record<string, any> = {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
    Alert,
    AlertDescription,
    AlertTitle,
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
    Button,
    ButtonLabel,
    ButtonGroup,
    ButtonGroupSeparator,
    ButtonGroupText,
    Calendar,
    Checkbox,
    Title,
    Subtitle,
    Call,
    CallDescription,
    CallTitle,
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardFooter,
    CardTitle,
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselNextButton,
    CarouselPrevious,
    CarouselPreviousButton,
    CheckboxSlate,
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuTrigger,
    DropdownMenuItem,
    FieldIconButton,
    FlowProgress,
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
    Input,
    InputOTP,
    InputOTPGroup,
    InputOTPSeparator,
    InputOTPSlot,
    Label,
    Popover,
    PopoverContent,
    PopoverTrigger,
    RadioGroup,
    RadioGroupItem,
    RadioCardGroup,
    RadioCardItem,
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup,
    ScrollArea,
    ScrollBar,
    Separator,
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
    SelectGroup,
    SelectLabel,
    NativeSelect,
    NativeSelectOption,
    NativeSelectOptGroup,
    Skeleton,
    Section,
    SectionTitle,
    Sheet,
    SheetClose,
    SheetContent,
    SheetDescription,
    SheetFooter,
    SheetHeader,
    SheetOverlay,
    SheetPortal,
    SheetTitle,
    SheetTrigger,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableCaption,
    TableHead,
    TableHeader,
    TableRow,
    Textarea,
    Tabs,
    TabsList,
    TabsContent,
    TabsTrigger,
    NavTabs,
    NavTabsList,
    NavTabsLink,
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    FormBadge,
    FormBadgeGroup,
    FormInfoRow,
    FormSectionCard,
    FormPrevalenceBadge,
    FormStatusBadge,
    FormImportanceBadge,
    FormScoringBadge,
    SubscriptionPlanBadge,
    Toast,
    ToastAction,
    ToastClose,
    ToastDescription,
    ToastProvider,
    ToastTitle,
    ToastViewport,
    useToast,
    toast,
    cn,
    MultiSelect,
};

// Export individual components as well
export {
    cn,
    Title,
    Subtitle,
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
    Alert,
    AlertDescription,
    AlertTitle,
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
    Button,
    ButtonLabel,
    ButtonGroup,
    ButtonGroupSeparator,
    ButtonGroupText,
    Calendar,
    Checkbox,
    Call,
    CallDescription,
    CallTitle,
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselNextButton,
    CarouselPrevious,
    CarouselPreviousButton,
    CheckboxSlate,
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuTrigger,
    DropdownMenuItem,
    FieldIconButton,
    FlowProgress,
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
    Input,
    InputOTP,
    InputOTPGroup,
    InputOTPSeparator,
    InputOTPSlot,
    Label,
    Popover,
    PopoverContent,
    PopoverTrigger,
    RadioGroup,
    RadioGroupItem,
    RadioCardGroup,
    RadioCardItem,
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup,
    ScrollArea,
    ScrollBar,
    Separator,
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
    SelectGroup,
    SelectLabel,
    NativeSelect,
    NativeSelectOption,
    NativeSelectOptGroup,
    Skeleton,
    Section,
    SectionTitle,
    Sheet,
    SheetClose,
    SheetContent,
    SheetDescription,
    SheetFooter,
    SheetHeader,
    SheetOverlay,
    SheetPortal,
    SheetTitle,
    SheetTrigger,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableCaption,
    TableHead,
    TableHeader,
    TableRow,
    Textarea,
    Tabs,
    TabsList,
    TabsContent,
    TabsTrigger,
    NavTabs,
    NavTabsList,
    NavTabsLink,
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    FormBadge,
    FormBadgeGroup,
    FormInfoRow,
    FormSectionCard,
    FormPrevalenceBadge,
    FormStatusBadge,
    FormImportanceBadge,
    FormScoringBadge,
    SubscriptionPlanBadge,
    Toast,
    ToastAction,
    ToastClose,
    ToastDescription,
    ToastProvider,
    ToastTitle,
    ToastViewport,
    useToast,
    toast,
    MultiSelect,
};

export type { FlowPhase, FlowPhaseStage } from "./flow-progress";

// Re-export utils
export * from "./utils";

// Re-export chart components
export * from "./chart";
